/* eslint-disable @next/next/next-script-for-ga */
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { ReactNode } from 'react'
const Footer = dynamic(() => import('../components/common/Footer'))
const Header = dynamic(() => import('../components/common/Header'))

interface LayoutProps {
  children: ReactNode
}

const ROUTES_DISCRETE_HEADER = [
  'wallet',
  'login',
  'send-asset',
  'save-contacts',
  'edit-contact',
  'contact',
  'buy-asset',
  'contacts/[index]',
  'contacts/editcontact/[index]',
  'all-assets',
]
const ROUTES_DISCRETE_FOOTER = [
  'wallet',
  'login',
  'send-asset',
  'all-assets',
  'buy-asset',
  'save-contacts',
  'contacts/[index]',
  'contacts/editcontact/[index]',
  'categories/[categoryid]',
  'categories/[categoryid]/search/[query]',
]

function Layout({ children }: LayoutProps) {
  const router = useRouter()

  return (
    <>
      <Head>
        <meta
          name="description"
          content="Alter is an ever altering ecosystem for next gen human
          evolution(sounds futuristic right, it is) & in process of achieving
          that we are looking for highly passionate & creative game builders to
          join our team(Yes, this website's current purpose is to hire talent)."
        />
        <meta name="keywords" content="Gaming" />
        <link
          rel="preload"
          href="/fonts/monumentextended-regular-webfont.woff"
          as="font"
          type="font/woff"
          crossOrigin="true"
        />
        <link
          rel="preload"
          href="/fonts/monumentextended-regular-webfont.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="true"
        />
        <link
          rel="preload"
          href="/fonts/monumentextended-ultrabold-webfont.woff"
          as="font"
          type="font/woff"
          crossOrigin="true"
        />
        <link
          rel="preload"
          href="/fonts/monumentextended-ultrabold-webfont.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="true"
        />
        {/* <meta property="og:title" content="AlterOS - Portal to metaverse" /> */}
        <meta property="og:type" content="image/jpeg" />
        <meta property="og:url" content="https://www.alter.game/" />
        <meta property="og:image" content="/icon_152x152.png" />
        <meta property="og:image:secure_url" content="/icon_152x152.png" />
        <meta property="og:image:alt" content="Logo of Alter" />
        <meta property="og:image:width" content="152" />
        <meta property="og:image:height" content="152" />
        <meta property="og:site_name" content="Alter" />
        <meta name="theme-color" content="#081223" />
        <link rel="canonical" href="https://www.alter.game/" />
        {/* Windows Phone  */}
        <meta name="msapplication-navbutton-color" content="#081223" />
        {/* iOS Safari */}
        <meta name="apple-mobile-web-app-status-bar-style" content="#081223" />
        <link rel="icon" href="/favicon.ico" />
        {/* <title>AlterOS - Portal to metaverse</title> */}
        <script
          type="module"
          src="https://unpkg.com/@google/model-viewer/dist/model-viewer.js"
        ></script>
        <script
          type="nomodule"
          src="https://unpkg.com/@google/model-viewer/dist/model-viewer-legacy.js"
        ></script>
        {/* <script
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NKWJVJS');`,
          }}
        /> */}
        <noscript>
          <iframe
            title="gtag"
            src="https://www.googletagmanager.com/ns.html?id=GTM-NKWJVJS"
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
      </Head>
      <div className="bg-black">
        <div className="bg-opacity-40 bg-pattern bg-cover bg-fixed bg-no-repeat pb-10 ">
          {!ROUTES_DISCRETE_HEADER.includes(router.route.slice(1)) ? (
            <>
              <Header />
              <div className="mt-28" />
            </>
          ) : (
            <></>
          )}
          {children}
        </div>
        {!ROUTES_DISCRETE_FOOTER.includes(router.route.slice(1)) ? (
          <Footer />
        ) : (
          <></>
        )}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.element,
}

export default Layout
